export default "__VITE_PUBLIC_ASSET__94b854bb__"